<template>
  <div>
    <q-btn label="Firmar" color="primary" @click="open" />
    <q-dialog v-model="alert">
      <q-card id="card-firma" style="min-width: 100%; min-height: 100%">
        
        <q-card-section style="min-width: 100%; min-height: 100%">
          <VueSignaturePad
            :width="width"
            :height="height"
            :options="options"
            saveType="image/jpeg" 
            ref="signaturePad"
            :customStyle="stylePad"
            id="canvas-firma"
          />
        </q-card-section>

        <q-card-actions align="right">
          <q-btn flat color="primary" label="Guardar" @click="save" />
          <q-btn flat color="secondary" label="Revertir" @click="undo" />
          <q-btn flat color="secondary" label="Borrar" @click="clear" />
          <q-btn flat color="secondary" label="Bloquear" @click="lock" />
          <q-btn flat color="secondary" label="Desbloquear" @click="unlock" />
          <q-btn flat label="Cancel" color="primary" v-close-popup />
          <q-btn flat label="Turn on Wifi" color="primary" v-close-popup />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
import {authHeader} from './../_helpers/_auth-header'
import {dataURItoBlob} from './../_helpers/dataURItoBlob'
import axios from 'axios'
import { mapMutations, mapActions } from 'vuex'
import VueSignaturePad from 'vue-signature-pad'

Vue.use(VueSignaturePad);

export default {
  props: ['empresa_id', 'pedido_id'],
  name: 'FirmaClear',
  data() {
    return {
      alert: false,
      width: '100%',
      height: '100%',
      heightDialog: null,
      options: {
        // backgroundColor: 'rgb(221, 221, 221)',
        backgroundColor: 'rgb(255, 255, 255)',
      },
      stylePad: {
        border: 'black 1px solid'
      },
      dataURI: ''
    }
  },
  computed: {
    urlApiPedidoArchivos() {
      return this.$store.state.urlBase + `/api/v3/${this.empresa_id}/pedidos/archivos/${this.pedido_id}`;
    },
    firma() {
      return this.$store.state.firma.dataURI;
    }
  },
  methods: {
    ...mapMutations(['setFirma']),
    ...mapActions(['storeFirma']),
    open() {
      this.alert = true;
      this.$nextTick(function () {
        console.log('mirando dimensiones');
        let panelFirma = document.getElementById('card-firma');
        console.log(panelFirma.offsetWidth, panelFirma.offsetHeight);
        this.height = panelFirma.offsetHeight - 150 + 'px';
        // this.$refs.signaturePad.clearSignature();
        this.$refs.signaturePad.resizeCanvas();

      })
    },
    undo() {
      this.$refs.signaturePad.undoSignature();
    },
    save() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      
      if (!isEmpty) {
        this.dataURI = data;
        this.setFirma({
          dataURI: data, 
          empresa_id: this.empresa_id, 
          pedido_id: this.pedido_id
          });
        this.clear();
      } else {
        this.dataURI = '';
      }
    },
    clear() {
      this.$refs.signaturePad.clearSignature();
    },
    lock() {
      this.$refs.signaturePad.lockSignaturePad();
    },
    unlock() {
      this.$refs.signaturePad.openSignaturePad();
    },
    resizeCanvas(event) {
      
      this.$nextTick(function () {
        console.log('redimensionando canvas');
        let canvas = document.getElementsByTagName('canvas')[0];
        let panelFirma = document.getElementById('panel-firma');
        var ratio =  Math.max(window.devicePixelRatio || 1, 1);

        console.log('canvas:',canvas.offsetWidth, canvas.offsetHeight);
        console.log('panelFirma:',panelFirma.offsetWidth, panelFirma.offsetHeight);
        // canvas.width = canvas.offsetWidth * ratio;
        // canvas.height = canvas.offsetHeight  * ratio;
        canvas.width = panelFirma.offsetWidth * ratio;
        canvas.height = panelFirma.offsetHeight * ratio;
        // console.log(this.width, this.height);
        
        canvas.getContext("2d").scale(ratio, ratio);
        // signaturePad.clear(); // otherwise isEmpty() might return incorrect value
        // signaturePad.clear()

        console.log('dentro de nextTick resize');
        this.$refs.signaturePad.clearSignature();
        this.$refs.signaturePad.resizeCanvas();
      })
    },
    resizeCanvas2(event) {
      console.log('resize 2');
      let canvas = document.getElementsByTagName('canvas')[0];
      let panelFirma = document.getElementById('panel-firma');
      
      console.log('canvas:',canvas.offsetWidth, canvas.offsetHeight);
      console.log('panelFirma:',panelFirma.offsetWidth, panelFirma.offsetHeight);
      
      this.$refs.signaturePad.clearSignature();
      this.$refs.signaturePad.resizeCanvas();
    },

  },
  mounted() {
    console.log('componente firma montado');
  },
  created() {
    console.log('componente firma creado');
  },
  deactivated() {
    console.log('desactivando componente firma');
    // window.removeEventListener('resize', this.resizeCanvas);
    },
  activated() {
    console.log('activando componente firma');
    let cardFirma = document.getElementById('card-firma');
    // console.log('cardFirma:',cardFirma.offsetWidth, cardFirma.offsetHeight);
    // window.addEventListener("resize", this.resizeCanvas);
  }
}
</script>

<style lang="scss">

</style>